import { AuthenticationMode } from '../config/app.config';

export interface AuthenticationFormVisibility {
  showCedula: boolean;
  showEmailPassword: boolean;
}

export interface BackendAuthenticationMetadata {
  emailVerificationRequired?: boolean;
  firebaseEmailChanged?: boolean;
  firebaseClaimsChanged?: boolean;
  profileSyncPending?: boolean;
}

export interface PostLoginAuthenticationActions {
  allowAccess: true;
  refreshFirebaseUser: boolean;
  showVerificationNotice: boolean;
  recordProfileSyncPending: boolean;
}

export const getAuthenticationFormVisibility = (
  mode?: AuthenticationMode | null
): AuthenticationFormVisibility => ({
  showCedula: mode === 'cedula',
  showEmailPassword: mode === 'email_password'
});

export const getCredentialAuthenticationErrorMessage = (code?: string): string => {
  switch (code) {
    case 'AUTH_MODE_MISMATCH':
      return 'El método de acceso cambió. Actualice esta pantalla e intente nuevamente.';
    case 'PARTICIPANT_NOT_FOUND':
      return 'La cuenta no está vinculada con una inscripción válida para este evento.';
    case 'CLIENT_NOT_CONFIGURED':
    case 'FIREBASE_ADMIN_NOT_CONFIGURED':
      return 'El servicio de acceso no está disponible temporalmente.';
    case 'auth/too-many-requests':
      return 'Se realizaron demasiados intentos. Espere unos minutos antes de volver a intentar.';
    default:
      return 'El correo electrónico o la clave no son correctos. Puede activar o recuperar su acceso.';
  }
};

export const getAccessRequestErrorMessage = (code?: string): string => {
  switch (code) {
    case 'TOO_MANY_REQUESTS':
      return 'Se realizaron demasiadas solicitudes. Espere antes de solicitar otro correo.';
    case 'FIREBASE_ADMIN_NOT_CONFIGURED':
      return 'El servicio de acceso no está disponible temporalmente.';
    case 'CREDENTIAL_AUTH_NOT_ENABLED':
      return 'Este evento no tiene habilitado el acceso con correo y clave.';
    case 'REQUEST_TIMEOUT':
      return 'La solicitud tardó demasiado. Verifique su conexión e intente nuevamente.';
    case 'NETWORK_ERROR':
      return 'No se pudo conectar con el servidor. Verifique su conexión.';
    default:
      return 'El servicio no está disponible en este momento. Intente nuevamente.';
  }
};

export const getPostLoginAuthenticationActions = (
  metadata: BackendAuthenticationMetadata
): PostLoginAuthenticationActions => ({
  allowAccess: true,
  refreshFirebaseUser: Boolean(metadata.firebaseEmailChanged || metadata.firebaseClaimsChanged),
  showVerificationNotice: Boolean(metadata.emailVerificationRequired),
  recordProfileSyncPending: Boolean(metadata.profileSyncPending)
});
